import React from 'react';

export default () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.5 4.8125H6.125V7.4375H3.5V4.8125Z" fill="currentColor" />
    <path d="M3.5 9.1875H6.125V11.8125H3.5V9.1875Z" fill="currentColor" />
    <path d="M3.5 13.5625H6.125V16.1875H3.5V13.5625Z" fill="currentColor" />
    <path d="M7.875 4.8125H17.5V7.4375H7.875V4.8125Z" fill="currentColor" />
    <path d="M7.875 9.1875H17.5V11.8125H7.875V9.1875Z" fill="currentColor" />
    <path d="M7.875 13.5625H17.5V16.1875H7.875V13.5625Z" fill="currentColor" />
  </svg>
);
